export default __webpack_public_path__ + "static/media/dog2.c1bdc893.jpg";